// extracted by mini-css-extract-plugin
export default {"button":"SelectAddress_button__FcpWk","coins":"SelectAddress_coins__XDqEZ"};